import axios from "axios";
import { normalizeEtfScreenerResponse } from "./etf-screener.normalize";
import type { EtfScreenerQuery, EtfScreenerResponse } from "./etf-screener.type";

export const ETF_SCREENER_PROXY_PATH = "/data/etf-screener";

/**
 * Our own server's proxy (src/routes/data.etf-screener.ts): the gateway
 * route needs a key that must not reach the browser. Same origin, open to
 * every visitor.
 */
export const getEtfScreener = async (
  query: EtfScreenerQuery,
  options?: { signal?: AbortSignal },
): Promise<EtfScreenerResponse> => {
  const params: Record<string, string | number> = {};
  for (const [key, value] of Object.entries(query)) {
    if (value !== undefined && value !== "") params[key] = value;
  }
  const response = await axios.get<unknown>(ETF_SCREENER_PROXY_PATH, {
    params,
    signal: options?.signal,
  });
  return normalizeEtfScreenerResponse(response.data, query.limit);
};
